import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuardService } from './services/guard.service';

const routes: Routes = [
  {
    canActivate: [GuardService],
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'ocr-guideline',
    loadChildren: () => import('./pages/guidelines/ocr-guideline/ocr-guideline.module').then(m => m.OcrGuidelinePageModule)
  },
  {
    path: 'face-guideline',
    loadChildren: () => import('./pages/guidelines/face-guideline/face-guideline.module').then(m => m.FaceGuidelinePageModule)
  },

  {
    path: 'success',
    loadChildren: () => import('./pages/success/success.module').then(m => m.SuccessPageModule)
  },
  {
    path: 'verify-otp',
    loadChildren: () => import('./modals/verify-otp/verify-otp.module').then(m => m.VerifyOtpPageModule)
  },
  {
    path: 'term-condition',
    loadChildren: () => import('./pages/term-condition/term-condition.module').then(m => m.TermConditionPageModule)
  },
  {
    path: 'id-card-info',
    loadChildren: () => import('./pages/id-card-info/id-card-info.module').then(m => m.IdCardInfoPageModule)
  },
  {
    path: 'phone-number',
    loadChildren: () => import('./pages/phone-number/phone-number.module').then(m => m.PhoneNumberPageModule)
  },
  {
    path: 'processing',
    loadChildren: () => import('./pages/processing/processing.module').then(m => m.ProcessingPageModule)
  },
  {
    path: 'confirm-img',
    loadChildren: () => import('./pages/confirm-img/confirm-img.module').then(m => m.ConfirmImgPageModule)
  },
  {
    path: 'edit-card-info',
    loadChildren: () => import('./modals/edit-card-info/edit-card-info.module').then(m => m.EditCardInfoPageModule)
  },
  {
    path: 'face-preview',
    loadChildren: () => import('./pages/face-preview/face-preview.module').then(m => m.FacePreviewPageModule)
  },
  {
    path: 'numpad-phone',
    loadChildren: () => import('./modals/numpad-phone/numpad-phone.module').then(m => m.NumpadPhonePageModule)
  },
  {
    path: 'main-guideline',
    loadChildren: () => import('./pages/guidelines/main-guideline/main-guideline.module').then(m => m.MainGuidelinePageModule)
  },
  {
    path: 'confirm-otp',
    loadChildren: () => import('./pages/confirm-otp/confirm-otp.module').then(m => m.ConfirmOtpPageModule)
  },
  {
    path: 'email',
    loadChildren: () => import('./pages/email/email.module').then(m => m.EmailPageModule)
  },
  {
    path: 'confirm-email',
    loadChildren: () => import('./pages/confirm-email/confirm-email.module').then(m => m.ConfirmEmailPageModule)
  },
  {
    path: 'consent',
    loadChildren: () => import('./pages/consent/consent.module').then(m => m.ConsentPageModule)
  },
  {
    path: 'ocr-document-front',
    loadChildren: () => import('./features/document-detection/thai-id-front-pico/pages/capture/capture.module').then(m => m.ThaiIdFrontPicoCaptureModule)
  },
  {
    path: 'ocr-document-back',
    loadChildren: () => import('./features/document-detection/thai-id-back/pages/capture/capture.module').then(m => m.ThaiIdBackCaptureModule)
  },
  {
    path: 'loading',
    loadChildren: () => import('./pages/loading/loading.module').then(m => m.LoadingPageModule)
  },
  {
    path: 'face-capture',
    loadChildren: () => import('./pages/face-capture/face-capture.module').then(m => m.FaceCapturePageModule)
  },
  {
    path: 'loan-info',
    loadChildren: () => import('./pages/loan-info/loan-info.module').then(m => m.LoanInfoPageModule)
  },
  {
    path: 'thai-d',
    loadChildren: () => import('./pages/thai-d/thai-d.module').then(m => m.ThaidPageModule)
  },

  {
    path: 'select-service',
    loadChildren: () => import('./pages/select-loan-type/select-loan-type.module').then(m => m.SelectLoanTypePageModule)
  },
  {
    path: 'product-info',
    loadChildren: () => import('./pages/product-info/product-info.module').then(m => m.ProductInfoPageModule)
  }
  ,
  {
    path: 'edit-address',
    loadChildren: () => import('./modals/edit-address/edit-address.module').then(m => m.EditAddressPageModule)
  },
  {
    path: 'edit-loan-info',
    loadChildren: () => import('./modals/edit-loan-info/edit-loan-info.module').then(m => m.EditLoanInfoPageModule)
  },
  {
    path: 'address',
    loadChildren: () => import('./pages/address/address.module').then(m => m.AddressPageModule)
  },
  {
    path: 'upload-file',
    loadChildren: () => import('./modals/upload-file/upload-file.module').then(m => m.UploadFilePageModule)
  },
  {
    path: 'fail',
    loadChildren: () => import('./pages/fail/fail.module').then(m => m.FailPageModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule)
  },
  {
    path: 'working-info',
    loadChildren: () => import('./pages/working-info/working-info.module').then(m => m.WorkingInfoPageModule)
  },
  {
    path: 'edit-working-info',
    loadChildren: () => import('./modals/edit-working-info/edit-working-info.module').then(m => m.EditWorkingInfoPageModule)
  },
  {
    path: 'select-installment-product',
    loadChildren: () => import('./pages/select-installment-product/select-installment-product.module').then(m => m.SelectInstallmentProductPageModule)
  },
  {
    path: 'attach-evidence',
    loadChildren: () => import('./pages/attach-evidence/attach-evidence.module').then(m => m.AttachEvidencePageModule)
  },
  {
    path: 'device-preparation',
    loadChildren: () => import('./pages/device-preparation/device-preparation.module').then(m => m.DevicePreparationPageModule)
  },
  {
    path: 'device-check',
    loadChildren: () => import('./pages/device-check/device-check.module').then(m => m.DeviceCheckPageModule)
  },
  {
    path: 'add-product',
    loadChildren: () => import('./modals/product/add-product/add-product.module').then(m => m.AddProductPageModule)
  },
  {
    path: 'device-failed',
    loadChildren: () => import('./pages/device-failed/device-failed.module').then(m => m.DeviceFailedPageModule)
  },
  {
    path: 'select-verify-method',
    loadChildren: () => import('./pages/select-verify-method/select-verify-method.module').then(m => m.SelectVerifyMethodPageModule)
  },
  {
    path: 'verify-methods',
    loadChildren: () => import('./modals/verify-methods/verify-methods.module').then(m => m.VerifyMethodsPageModule)
  },
  {
    path: 'landing-resume-stage',
    loadChildren: () => import('./pages/landing-resume-stage/landing-resume-stage.module').then(m => m.LandingResumeStagePageModule)
  },
  {
    path: 'installment',
    loadChildren: () => import('./modals/product/installment/installment.module').then(m => m.InstallmentPageModule)
  },
  {
    path: 'installment-detail',
    loadChildren: () => import('./modals/product/installment-detail/installment-detail.module').then(m => m.InstallmentDetailPageModule)
  },
  {
    path: 'filter-product',
    loadChildren: () => import('./modals/product/filter-product/filter-product.module').then(m => m.FilterProductPageModule)
  },
  {
    path: 'product-detail',
    loadChildren: () => import('./modals/product/product-detail/product-detail.module').then(m => m.ProductDetailPageModule)
  },
  {
    path: 'specify-credit-limit',
    loadChildren: () => import('./modals/product/specify-credit-limit/specify-credit-limit.module').then(m => m.SpecifyCreditLimitPageModule)
  },
  {
    path: 'confirm-term',
    loadChildren: () => import('./modals/confirm-term/confirm-term.module').then(m => m.ConfirmTermPageModule)
  },
  {
    path: 'end',
    loadChildren: () => import('./pages/end/end.module').then(m => m.EndPageModule)
  },
  {
    path: 'browser-check',
    loadChildren: () => import('./pages/browser-check/browser-check.module').then(m => m.BrowserCheckPageModule)
  },
  {
    path: 'cancel-register',
    loadChildren: () => import('./pages/cancel-register/cancel-register.module').then(m => m.CancelRegisterPageModule)
  },
  {
    path: 'd/:slug',
    loadChildren: () => import('./pages/load-document/load-document.module').then(m => m.LoadDocumentPageModule)
  },
  {
    path: 'nf/:slug',
    loadChildren: () => import('./pages/txn-not-found/txn-not-found.module').then(m => m.TxnNotFoundPageModule)
  },
  {
    path: 'verify-user-access',
    loadChildren: () => import('./modals/verify-user-access/verify-user-access.module').then(m => m.VerifyUserAccessPageModule)
  },







];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
